import DefaultCRUD from '../utils'

const resource = `/measurement/measurements`;

const { get } = DefaultCRUD(resource)

export default {
  get,
}
